// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { useContext } from 'react'
import modalContext from './modalContext'

/**
 * @typedef {Object} modalContextActions
 * @property {function} closeContextModal - closes the context modal
 * @property {function} openContextModal - takes the modal component and a config object
 */

/**
 * returns the context modal actions
 * @returns {modalContextActions}
 */

const useModalContext = () => (
  useContext(modalContext)
)

export default useModalContext
